import {FC} from 'react';
import {ECardStatic} from '~/QuickEcards/components/ECard/ECardStatic';
import {ViewEcard} from '~/QuickEcards/routes/ViewEcard/ViewEcard';
import {FlipBehavior} from '~/QuickEcards/types/ecard';
import {Button} from '~library/atoms/Button';
import {Typography} from '~library/atoms/Typography';

import './Preview.sass';

interface PreviewProps {
  isStatic?: boolean;
  showPreviewControls?: boolean;
  onClose?: () => void;
  flipBehavior?: FlipBehavior;
  hideBackground?: boolean;
  noAnim?: boolean;
  openFullPreview?: () => void;
  messageOverride?: string;
  ready?: boolean;
  hideReactionDrawer?: boolean;
  showTemplateMessage?: boolean;
}

export const Preview: FC<PreviewProps> = ({
  isStatic = false,
  showPreviewControls = false,
  onClose,
  flipBehavior = 'force',
  hideBackground = false,
  noAnim = false,
  openFullPreview,
  messageOverride,
  ready = true,
  hideReactionDrawer = true,
  showTemplateMessage = true,
}) => (
  <div className="quick-ecards__preview">
    {showPreviewControls && (
      <div className="quick-ecards__preview-banner" id="quick-ecards__preview-banner">
        <Typography variant="paragraph2" color="charcoal">
          Greeting Card preview
        </Typography>
        {onClose && (
          <Button
            variant="link"
            size="large"
            onClick={onClose}
            data-qa-id="close-preview"
            className="quick-ecards__preview-banner__close"
          >
            Go back
          </Button>
        )}
      </div>
    )}
    {isStatic ? (
      <ECardStatic hideBackground={hideBackground} />
    ) : (
      <ViewEcard
        preview
        flipBehavior={flipBehavior}
        hideBackground={hideBackground}
        noAnim={noAnim}
        openFullPreview={openFullPreview}
        messageOverride={messageOverride}
        ready={ready}
        hideReactionDrawer={hideReactionDrawer}
        showTemplateMessage={showTemplateMessage}
      />
    )}
  </div>
);
